import { createContext, useContext } from 'react';
import type { SandboxRunnerContextValue } from './types';

export const SandboxRunnerContext = createContext<SandboxRunnerContextValue | null>(null);

export function useSandboxRunner(): SandboxRunnerContextValue {
  const context = useContext(SandboxRunnerContext);
  if (!context) {
    throw new Error('useSandboxRunner must be used within a SandboxRunnerProvider');
  }
  return context;
}
